export default __webpack_public_path__ + "static/media/myb_footer.a8162a1f.svg";